import { b as bootstrapLazy } from './index-c4b9f73b.js';
import { a as patchEsm } from './patch-12616ce6.js';

var defineCustomElements = function defineCustomElements(win, options) {
  if (typeof window === 'undefined') return Promise.resolve();
  return patchEsm().then(function () {
    return bootstrapLazy([["app-home", [[1, "app-home"]]], ["app-profile", [[1, "app-profile", {
      "match": [16]
    }]]], ["context-consumer", [[0, "context-consumer", {
      "context": [16],
      "renderer": [16],
      "subscribe": [16],
      "unsubscribe": [32]
    }]]], ["stencil-async-content", [[0, "stencil-async-content", {
      "documentLocation": [1, "document-location"],
      "content": [32]
    }]]], ["stencil-route", [[0, "stencil-route", {
      "group": [513],
      "componentUpdated": [16],
      "match": [1040],
      "url": [1],
      "component": [1],
      "componentProps": [16],
      "exact": [4],
      "routeRender": [16],
      "scrollTopOffset": [2, "scroll-top-offset"],
      "routeViewsUpdated": [16],
      "location": [16],
      "history": [16],
      "historyType": [1, "history-type"]
    }]]], ["stencil-route-switch", [[4, "stencil-route-switch", {
      "group": [513],
      "scrollTopOffset": [2, "scroll-top-offset"],
      "location": [16],
      "routeViewsUpdated": [16]
    }]]], ["stencil-route-title", [[0, "stencil-route-title", {
      "titleSuffix": [1, "title-suffix"],
      "pageTitle": [1, "page-title"]
    }]]], ["stencil-router", [[4, "stencil-router", {
      "root": [1],
      "historyType": [1, "history-type"],
      "titleSuffix": [1, "title-suffix"],
      "scrollTopOffset": [2, "scroll-top-offset"],
      "location": [32],
      "history": [32]
    }]]], ["stencil-router-prompt", [[0, "stencil-router-prompt", {
      "when": [4],
      "message": [1],
      "history": [16],
      "unblock": [32]
    }]]], ["stencil-router-redirect", [[0, "stencil-router-redirect", {
      "history": [16],
      "root": [1],
      "url": [1]
    }]]], ["stencil-route-link", [[4, "stencil-route-link", {
      "url": [1],
      "urlMatch": [1, "url-match"],
      "activeClass": [1, "active-class"],
      "exact": [4],
      "strict": [4],
      "custom": [1],
      "anchorClass": [1, "anchor-class"],
      "anchorRole": [1, "anchor-role"],
      "anchorTitle": [1, "anchor-title"],
      "anchorTabIndex": [1, "anchor-tab-index"],
      "anchorId": [1, "anchor-id"],
      "history": [16],
      "location": [16],
      "root": [1],
      "ariaHaspopup": [1, "aria-haspopup"],
      "ariaPosinset": [1, "aria-posinset"],
      "ariaSetsize": [2, "aria-setsize"],
      "ariaLabel": [1, "aria-label"],
      "match": [32]
    }]]], ["app-root_3", [[1, "app-root", {
      "hideShelf": [32],
      "additionalCards": [32],
      "count": [32],
      "hasMoreCards": [32]
    }], [1, "remoco-card", {
      "image": [1],
      "locked": [4],
      "description": [1],
      "duration": [1],
      "href": [1],
      "ctitle": [1],
      "lockedOverride": [32],
      "setLockedOverride": [64]
    }], [1, "remoco-shelf", {
      "hasmorecards": [1],
      "locked": [4],
      "shelftitle": [1],
      "snapToCard": [4, "snap-to-card"],
      "numcards": [1],
      "atMin": [32],
      "atMax": [32],
      "els": [32],
      "enableSnapToCard": [32],
      "_enableSnapToCard": [32],
      "numPages": [32],
      "scrollCardMap": [32],
      "cardWidth": [32],
      "maxScroll": [32],
      "scrollPageMap": [32],
      "numFullCardsPerPage": [32]
    }, [[9, "resize", "onWindowResize"], [0, "focusin", "onFocusIn"], [0, "focusout", "onFocusOut"]]]]]], options);
  });
};

export { defineCustomElements };